import { CLASSY_PARAMS } from './params.constants'
import { Params } from './params.types'

/**
 * Given an href string, this function extracts the url parameters supported by Classy.
 */
export const extractClassyParamsFromHref = (href: string): Params => {
  const urlSearchParams = new URLSearchParams(href)

  const params: { [key: string]: string } = {}

  for (const [key, value] of urlSearchParams.entries()) {
    if (CLASSY_PARAMS.indexOf(key) !== -1) {
      params[key] = value as keyof Params
    }
  }

  return params as Params
}
